import wcclogo from '../assets/wcc_logo.png';
import iccLogo from '../assets/icc_crictos_logo.svg';
import oktoLogo from '../assets/okto.svg';
import threePattiLogo from '../assets/3-patti.png';
import voiceClubLogo from '../assets/voice-club.webp';
import faugLogo from '../assets/faug.webp';
import jigriLogo from '../assets/jigri.webp';

// User credentials for login
export const USERS = [
  { email: 'rahul@getstan.app', password: 'stan_123' },
  { email: 'saransh.ghunawat@getstan.app', password: 'stan_saransh-123' },
  { email: 'strategy@getstan.app', password: 'stan123' },
  // Add more users as needed
];

const DUMMY_DATA = {
  'okto': {
    logo: oktoLogo,
    name: 'Okto',
    projects: {
      'Prod': {
        logo: oktoLogo,
        name: 'Prod',
        stats: [
          { date: '2024-11-01', mau: 588442, installs: 145500 },
          { date: '2024-12-01', mau: 431026, installs: 6203 },
          { date: '2025-01-01', mau: 306440, installs: 10194 },
          { date: '2025-02-01', mau: 643276, installs: 63179 },
          { date: '2025-03-01', mau: 560029, installs: 13361 },
          { date: '2025-04-01', mau: 592076, installs: 5067 },
          { date: '2025-05-01', mau: 820216, installs: 44586 },
          { date: '2025-06-01', mau: 883956, installs: 35335 },
          { date: '2025-07-01', mau: 306166, installs: 12394 },
        ],
        days : [			
          { date :	'2024-11-01',	total :	22949},
          { date :	'2024-11-02',	total :	14123},
          { date :	'2024-11-03',	total :	15299},
          { date :	'2024-11-04',	total :	15299},
          { date :	'2024-11-05',	total :	18242},
          { date :	'2024-11-06',	total :	28245},
          { date :	'2024-11-07',	total :	20007},
          { date :	'2024-11-08',	total :	13534},
          { date :	'2024-11-09',	total :	18830},
          { date :	'2024-11-10',	total :	21184},
          { date :	'2024-11-11',	total :	13534},
          { date :	'2024-11-12',	total :	20595},
          { date :	'2024-11-13',	total :	23538},
          { date :	'2024-11-14',	total :	21772},
          { date :	'2024-11-15',	total :	26480},
          { date :	'2024-11-16',	total :	18830},
          { date :	'2024-11-17',	total :	28245},
          { date :	'2024-11-18',	total :	22361},
          { date :	'2024-11-19',	total :	21772},
          { date :	'2024-11-20',	total :	18242},
          { date :	'2024-11-21',	total :	19419},
          { date :	'2024-11-22',	total :	15888},
          { date :	'2024-11-23',	total :	27657},
          { date :	'2024-11-24',	total :	14123},
          { date :	'2024-11-25',	total :	17065},
          { date :	'2024-11-26',	total :	29422},
          { date :	'2024-11-27',	total :	18830},
          { date :	'2024-11-28',	total :	14123},
          { date :	'2024-11-29',	total :	17065},
          { date :	'2024-11-30',	total :	24126},
          { date :	'2024-12-01',	total :	10345},
          { date :	'2024-12-02',	total :	13793},
          { date :	'2024-12-03',	total :	17672},
          { date :	'2024-12-04',	total :	14655},
          { date :	'2024-12-05',	total :	8621},
          { date :	'2024-12-06',	total :	17672},
          { date :	'2024-12-07',	total :	21551},
          { date :	'2024-12-08',	total :	18103},
          { date :	'2024-12-09',	total :	18965},
          { date :	'2024-12-10',	total :	12069},
          { date :	'2024-12-11',	total :	21551},
          { date :	'2024-12-12',	total :	12931},
          { date :	'2024-12-13',	total :	12069},
          { date :	'2024-12-14',	total :	13793},
          { date :	'2024-12-15',	total :	14224},
          { date :	'2024-12-16',	total :	18534},
          { date :	'2024-12-17',	total :	15948},
          { date :	'2024-12-18',	total :	16379},
          { date :	'2024-12-19',	total :	14224},
          { date :	'2024-12-20',	total :	8621},
          { date :	'2024-12-21',	total :	18534},
          { date :	'2024-12-22',	total :	19396},
          { date :	'2024-12-23',	total :	19396},
          { date :	'2024-12-24',	total :	11638},
          { date :	'2024-12-25',	total :	10345},
          { date :	'2024-12-26',	total :	9483},
          { date :	'2024-12-27',	total :	11207},
          { date :	'2024-12-28',	total :	19827},
          { date :	'2024-12-29',	total :	15517},
          { date :	'2024-12-30',	total :	13793},
          { date :	'2024-12-31',	total :	15086},
          { date :	'2025-01-01',	total :	6742},
          { date :	'2025-01-02',	total :	7048},
          { date :	'2025-01-03',	total :	8887},
          { date :	'2025-01-04',	total :	7967},
          { date :	'2025-01-05',	total :	14096},
          { date :	'2025-01-06',	total :	15628},
          { date :	'2025-01-07',	total :	11951},
          { date :	'2025-01-08',	total :	18080},
          { date :	'2025-01-09',	total :	4597},
          { date :	'2025-01-10',	total :	5516},
          { date :	'2025-01-11',	total :	5209},
          { date :	'2025-01-12',	total :	5822},
          { date :	'2025-01-13',	total :	5209},
          { date :	'2025-01-14',	total :	4597},
          { date :	'2025-01-15',	total :	4597},
          { date :	'2025-01-16',	total :	5209},
          { date :	'2025-01-17',	total :	5822},
          { date :	'2025-01-18',	total :	4903},
          { date :	'2025-01-19',	total :	5209},
          { date :	'2025-01-20',	total :	4597},
          { date :	'2025-01-21',	total :	5516},
          { date :	'2025-01-22',	total :	4597},
          { date :	'2025-01-23',	total :	5209},
          { date :	'2025-01-24',	total :	5516},
          { date :	'2025-01-25',	total :	4903},
          { date :	'2025-01-26',	total :	4597},
          { date :	'2025-01-27',	total :	4597},
          { date :	'2025-01-28',	total :	5822},
          { date :	'2025-01-29',	total :	8580},
          { date :	'2025-01-30',	total :	7967},
          { date :	'2025-01-31',	total :	6129},
          { date :	'2025-02-01',	total :	17368},
          { date :	'2025-02-02',	total :	13509},
          { date :	'2025-02-03',	total :	18655},
          { date :	'2025-02-04',	total :	12866},
          { date :	'2025-02-05',	total :	14795},
          { date :	'2025-02-06',	total :	19298},
          { date :	'2025-02-07',	total :	13509},
          { date :	'2025-02-08',	total :	15439},
          { date :	'2025-02-09',	total :	19298},
          { date :	'2025-02-10',	total :	16725},
          { date :	'2025-02-11',	total :	16725},
          { date :	'2025-02-12',	total :	17368},
          { date :	'2025-02-13',	total :	15439},
          { date :	'2025-02-14',	total :	16082},
          { date :	'2025-02-15',	total :	12866},
          { date :	'2025-02-16',	total :	17368},
          { date :	'2025-02-17',	total :	18655},
          { date :	'2025-02-18',	total :	16725},
          { date :	'2025-02-19',	total :	12866},
          { date :	'2025-02-20',	total :	13509},
          { date :	'2025-02-21',	total :	15439},
          { date :	'2025-02-22',	total :	15439},
          { date :	'2025-02-23',	total :	13509},
          { date :	'2025-02-24',	total :	14795},
          { date :	'2025-02-25',	total :	18012},
          { date :	'2025-02-26',	total :	21871},
          { date :	'2025-02-27',	total :	23158},
          { date :	'2025-02-28',	total :	23801},
          { date :	'2025-03-01',	total :	23521},
          { date :	'2025-03-02',	total :	26321},
          { date :	'2025-03-03',	total :	24081},
          { date :	'2025-03-04',	total :	12321},
          { date :	'2025-03-05',	total :	20721},
          { date :	'2025-03-06',	total :	15681},
          { date :	'2025-03-07',	total :	15681},
          { date :	'2025-03-08',	total :	28001},
          { date :	'2025-03-09',	total :	12881},
          { date :	'2025-03-10',	total :	11761},
          { date :	'2025-03-11',	total :	16241},
          { date :	'2025-03-12',	total :	17921},
          { date :	'2025-03-13',	total :	17361},
          { date :	'2025-03-14',	total :	19601},
          { date :	'2025-03-15',	total :	14561},
          { date :	'2025-03-16',	total :	20721},
          { date :	'2025-03-17',	total :	26321},
          { date :	'2025-03-18',	total :	17361},
          { date :	'2025-03-19',	total :	12321},
          { date :	'2025-03-20',	total :	21281},
          { date :	'2025-03-21',	total :	24641},
          { date :	'2025-03-22',	total :	26321},
          { date :	'2025-03-23',	total :	27441},
          { date :	'2025-03-24',	total :	16801},
          { date :	'2025-03-25',	total :	24081},
          { date :	'2025-03-26',	total :	24081},
          { date :	'2025-03-27',	total :	26321},
          { date :	'2025-03-28',	total :	20721},
          { date :	'2025-03-29',	total :	27441},
          { date :	'2025-03-30',	total :	24641},
          { date :	'2025-03-31',	total :	24081},
          { date :	'2025-04-01',	total :	14802},
          { date :	'2025-04-02',	total :	29012},
          { date :	'2025-04-03',	total :	20723},
          { date :	'2025-04-04',	total :	26643},
          { date :	'2025-04-05',	total :	17762},
          { date :	'2025-04-06',	total :	16578},
          { date :	'2025-04-07',	total :	14210},
          { date :	'2025-04-08',	total :	21907},
          { date :	'2025-04-09',	total :	15986},
          { date :	'2025-04-10',	total :	20131},
          { date :	'2025-04-11',	total :	16578},
          { date :	'2025-04-12',	total :	24275},
          { date :	'2025-04-13',	total :	26643},
          { date :	'2025-04-14',	total :	21315},
          { date :	'2025-04-15',	total :	25459},
          { date :	'2025-04-16',	total :	26643},
          { date :	'2025-04-17',	total :	23091},
          { date :	'2025-04-18',	total :	14210},
          { date :	'2025-04-19',	total :	26051},
          { date :	'2025-04-20',	total :	29012},
          { date :	'2025-04-21',	total :	29604},
          { date :	'2025-04-22',	total :	11842},
          { date :	'2025-04-23',	total :	21907},
          { date :	'2025-04-24',	total :	13026},
          { date :	'2025-04-25',	total :	20723},
          { date :	'2025-04-26',	total :	14210},
          { date :	'2025-04-27',	total :	17170},
          { date :	'2025-04-28',	total :	22499},
          { date :	'2025-04-29',	total :	27235},
          { date :	'2025-04-30',	total :	25459},
          { date :	'2025-05-01',	total :	38550},
          { date :	'2025-05-02',	total :	40191},
          { date :	'2025-05-03',	total :	34449},
          { date :	'2025-05-04',	total :	32809},
          { date :	'2025-05-05',	total :	32809},
          { date :	'2025-05-06',	total :	33629},
          { date :	'2025-05-07',	total :	33629},
          { date :	'2025-05-08',	total :	36910},
          { date :	'2025-05-09',	total :	34449},
          { date :	'2025-05-10',	total :	35269},
          { date :	'2025-05-11',	total :	34449},
          { date :	'2025-05-12',	total :	38550},
          { date :	'2025-05-13',	total :	39370},
          { date :	'2025-05-14',	total :	36910},
          { date :	'2025-05-15',	total :	37730},
          { date :	'2025-05-16',	total :	37730},
          { date :	'2025-05-17',	total :	40191},
          { date :	'2025-05-18',	total :	41011},
          { date :	'2025-05-19',	total :	40191},
          { date :	'2025-05-20',	total :	37730},
          { date :	'2025-05-21',	total :	40191},
          { date :	'2025-05-22',	total :	32809},
          { date :	'2025-05-23',	total :	36090},
          { date :	'2025-05-24',	total :	32809},
          { date :	'2025-05-25',	total :	36910},
          { date :	'2025-05-26',	total :	33629},
          { date :	'2025-05-27',	total :	36090},
          { date :	'2025-05-28',	total :	36090},
          { date :	'2025-05-29',	total :	36910},
          { date :	'2025-05-30',	total :	37730},
          { date :	'2025-05-31',	total :	35269},
          { date :	'2025-06-01',	total :	41546},
          { date :	'2025-06-02',	total :	41546},
          { date :	'2025-06-03',	total :	38894},
          { date :	'2025-06-04',	total :	41546},
          { date :	'2025-06-05',	total :	39778},
          { date :	'2025-06-06',	total :	40662},
          { date :	'2025-06-07',	total :	42430},
          { date :	'2025-06-08',	total :	41546},
          { date :	'2025-06-09',	total :	44198},
          { date :	'2025-06-10',	total :	40662},
          { date :	'2025-06-11',	total :	35358},
          { date :	'2025-06-12',	total :	42430},
          { date :	'2025-06-13',	total :	43314},
          { date :	'2025-06-14',	total :	38010},
          { date :	'2025-06-15',	total :	42430},
          { date :	'2025-06-16',	total :	38010},
          { date :	'2025-06-17',	total :	44198},
          { date :	'2025-06-18',	total :	38894},
          { date :	'2025-06-19',	total :	38894},
          { date :	'2025-06-20',	total :	35358},
          { date :	'2025-06-21',	total :	39778},
          { date :	'2025-06-22',	total :	38010},
          { date :	'2025-06-23',	total :	38010},
          { date :	'2025-06-24',	total :	43314},
          { date :	'2025-06-25',	total :	39778},
          { date :	'2025-06-26',	total :	41546},
          { date :	'2025-06-27',	total :	41546},
          { date :	'2025-06-28',	total :	40662},
          { date :	'2025-06-29',	total :	36242},
          { date :	'2025-06-30',	total :	42430},
          { date :	'2025-07-01',	total :	43458},
          { date :	'2025-07-02',	total :	44152},
          { date :	'2025-07-03',	total :	41683},
          { date :	'2025-07-04',	total :	43478},
          { date :	'2025-07-05',	total :	42172},
          { date :	'2025-07-06',	total :	47253},
          { date :	'2025-07-07',	total :	46641},
          { date :	'2025-07-08',	total :	40315},
          { date :	'2025-07-09',	total :	41539},
          { date :	'2025-07-10',	total :	43152},
          { date :	'2025-07-11',	total :	30927},
          ],
        settings: [
          { label: 'API Key', value: 'sk-****-****-**ED' },
          { label: 'Webhook URL', value: 'https://apigw.okto.tech/s2s/api/v2/webhook/stan' },
          { label: 'Client ID', value: 'okto-cmeu9438ikssaoe-645' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
  '3-patti': {
    logo: threePattiLogo,
    name: '3-Patti',
    projects: {
      'Prod': {
        logo: threePattiLogo,
        name: 'Prod',
        stats: [
          { date: '2024-11-01', mau: 353065, installs: 90210 },
          { date: '2024-12-01', mau: 281487, installs: 5427 },
          { date: '2025-01-01', mau: 189993, installs: 8772 },
          { date: '2025-02-01', mau: 488889, installs: 42119 },
          { date: '2025-03-01', mau: 352611, installs: 9897 },
          { date: '2025-04-01', mau: 394717, installs: 3508 },
          { date: '2025-05-01', mau: 677569, installs: 35668 },
          { date: '2025-06-01', mau: 671807, installs: 29446 },
          { date: '2025-07-01', mau: 232546, installs: 10007 },
        ],
        days : [			
          { date :	'2024-11-01',	total :	22949},
          { date :	'2024-11-02',	total :	14123},
          { date :	'2024-11-03',	total :	15299},
          { date :	'2024-11-04',	total :	15299},
          { date :	'2024-11-05',	total :	18242},
          { date :	'2024-11-06',	total :	28245},
          { date :	'2024-11-07',	total :	20007},
          { date :	'2024-11-08',	total :	13534},
          { date :	'2024-11-09',	total :	18830},
          { date :	'2024-11-10',	total :	21184},
          { date :	'2024-11-11',	total :	13534},
          { date :	'2024-11-12',	total :	20595},
          { date :	'2024-11-13',	total :	23538},
          { date :	'2024-11-14',	total :	21772},
          { date :	'2024-11-15',	total :	26480},
          { date :	'2024-11-16',	total :	18830},
          { date :	'2024-11-17',	total :	28245},
          { date :	'2024-11-18',	total :	22361},
          { date :	'2024-11-19',	total :	21772},
          { date :	'2024-11-20',	total :	18242},
          { date :	'2024-11-21',	total :	19419},
          { date :	'2024-11-22',	total :	15888},
          { date :	'2024-11-23',	total :	27657},
          { date :	'2024-11-24',	total :	14123},
          { date :	'2024-11-25',	total :	17065},
          { date :	'2024-11-26',	total :	29422},
          { date :	'2024-11-27',	total :	18830},
          { date :	'2024-11-28',	total :	14123},
          { date :	'2024-11-29',	total :	17065},
          { date :	'2024-11-30',	total :	24126},
          { date :	'2024-12-01',	total :	10345},
          { date :	'2024-12-02',	total :	13793},
          { date :	'2024-12-03',	total :	17672},
          { date :	'2024-12-04',	total :	14655},
          { date :	'2024-12-05',	total :	8621},
          { date :	'2024-12-06',	total :	17672},
          { date :	'2024-12-07',	total :	21551},
          { date :	'2024-12-08',	total :	18103},
          { date :	'2024-12-09',	total :	18965},
          { date :	'2024-12-10',	total :	12069},
          { date :	'2024-12-11',	total :	21551},
          { date :	'2024-12-12',	total :	12931},
          { date :	'2024-12-13',	total :	12069},
          { date :	'2024-12-14',	total :	13793},
          { date :	'2024-12-15',	total :	14224},
          { date :	'2024-12-16',	total :	18534},
          { date :	'2024-12-17',	total :	15948},
          { date :	'2024-12-18',	total :	16379},
          { date :	'2024-12-19',	total :	14224},
          { date :	'2024-12-20',	total :	8621},
          { date :	'2024-12-21',	total :	18534},
          { date :	'2024-12-22',	total :	19396},
          { date :	'2024-12-23',	total :	19396},
          { date :	'2024-12-24',	total :	11638},
          { date :	'2024-12-25',	total :	10345},
          { date :	'2024-12-26',	total :	9483},
          { date :	'2024-12-27',	total :	11207},
          { date :	'2024-12-28',	total :	19827},
          { date :	'2024-12-29',	total :	15517},
          { date :	'2024-12-30',	total :	13793},
          { date :	'2024-12-31',	total :	15086},
          { date :	'2025-01-01',	total :	6742},
          { date :	'2025-01-02',	total :	7048},
          { date :	'2025-01-03',	total :	8887},
          { date :	'2025-01-04',	total :	7967},
          { date :	'2025-01-05',	total :	14096},
          { date :	'2025-01-06',	total :	15628},
          { date :	'2025-01-07',	total :	11951},
          { date :	'2025-01-08',	total :	18080},
          { date :	'2025-01-09',	total :	4597},
          { date :	'2025-01-10',	total :	5516},
          { date :	'2025-01-11',	total :	5209},
          { date :	'2025-01-12',	total :	5822},
          { date :	'2025-01-13',	total :	5209},
          { date :	'2025-01-14',	total :	4597},
          { date :	'2025-01-15',	total :	4597},
          { date :	'2025-01-16',	total :	5209},
          { date :	'2025-01-17',	total :	5822},
          { date :	'2025-01-18',	total :	4903},
          { date :	'2025-01-19',	total :	5209},
          { date :	'2025-01-20',	total :	4597},
          { date :	'2025-01-21',	total :	5516},
          { date :	'2025-01-22',	total :	4597},
          { date :	'2025-01-23',	total :	5209},
          { date :	'2025-01-24',	total :	5516},
          { date :	'2025-01-25',	total :	4903},
          { date :	'2025-01-26',	total :	4597},
          { date :	'2025-01-27',	total :	4597},
          { date :	'2025-01-28',	total :	5822},
          { date :	'2025-01-29',	total :	8580},
          { date :	'2025-01-30',	total :	7967},
          { date :	'2025-01-31',	total :	6129},
          { date :	'2025-02-01',	total :	17368},
          { date :	'2025-02-02',	total :	13509},
          { date :	'2025-02-03',	total :	18655},
          { date :	'2025-02-04',	total :	12866},
          { date :	'2025-02-05',	total :	14795},
          { date :	'2025-02-06',	total :	19298},
          { date :	'2025-02-07',	total :	13509},
          { date :	'2025-02-08',	total :	15439},
          { date :	'2025-02-09',	total :	19298},
          { date :	'2025-02-10',	total :	16725},
          { date :	'2025-02-11',	total :	16725},
          { date :	'2025-02-12',	total :	17368},
          { date :	'2025-02-13',	total :	15439},
          { date :	'2025-02-14',	total :	16082},
          { date :	'2025-02-15',	total :	12866},
          { date :	'2025-02-16',	total :	17368},
          { date :	'2025-02-17',	total :	18655},
          { date :	'2025-02-18',	total :	16725},
          { date :	'2025-02-19',	total :	12866},
          { date :	'2025-02-20',	total :	13509},
          { date :	'2025-02-21',	total :	15439},
          { date :	'2025-02-22',	total :	15439},
          { date :	'2025-02-23',	total :	13509},
          { date :	'2025-02-24',	total :	14795},
          { date :	'2025-02-25',	total :	18012},
          { date :	'2025-02-26',	total :	21871},
          { date :	'2025-02-27',	total :	23158},
          { date :	'2025-02-28',	total :	23801},
          { date :	'2025-03-01',	total :	23521},
          { date :	'2025-03-02',	total :	26321},
          { date :	'2025-03-03',	total :	24081},
          { date :	'2025-03-04',	total :	12321},
          { date :	'2025-03-05',	total :	20721},
          { date :	'2025-03-06',	total :	15681},
          { date :	'2025-03-07',	total :	15681},
          { date :	'2025-03-08',	total :	28001},
          { date :	'2025-03-09',	total :	12881},
          { date :	'2025-03-10',	total :	11761},
          { date :	'2025-03-11',	total :	16241},
          { date :	'2025-03-12',	total :	17921},
          { date :	'2025-03-13',	total :	17361},
          { date :	'2025-03-14',	total :	19601},
          { date :	'2025-03-15',	total :	14561},
          { date :	'2025-03-16',	total :	20721},
          { date :	'2025-03-17',	total :	26321},
          { date :	'2025-03-18',	total :	17361},
          { date :	'2025-03-19',	total :	12321},
          { date :	'2025-03-20',	total :	21281},
          { date :	'2025-03-21',	total :	24641},
          { date :	'2025-03-22',	total :	26321},
          { date :	'2025-03-23',	total :	27441},
          { date :	'2025-03-24',	total :	16801},
          { date :	'2025-03-25',	total :	24081},
          { date :	'2025-03-26',	total :	24081},
          { date :	'2025-03-27',	total :	26321},
          { date :	'2025-03-28',	total :	20721},
          { date :	'2025-03-29',	total :	27441},
          { date :	'2025-03-30',	total :	24641},
          { date :	'2025-03-31',	total :	24081},
          { date :	'2025-04-01',	total :	14802},
          { date :	'2025-04-02',	total :	29012},
          { date :	'2025-04-03',	total :	20723},
          { date :	'2025-04-04',	total :	26643},
          { date :	'2025-04-05',	total :	17762},
          { date :	'2025-04-06',	total :	16578},
          { date :	'2025-04-07',	total :	14210},
          { date :	'2025-04-08',	total :	21907},
          { date :	'2025-04-09',	total :	15986},
          { date :	'2025-04-10',	total :	20131},
          { date :	'2025-04-11',	total :	16578},
          { date :	'2025-04-12',	total :	24275},
          { date :	'2025-04-13',	total :	26643},
          { date :	'2025-04-14',	total :	21315},
          { date :	'2025-04-15',	total :	25459},
          { date :	'2025-04-16',	total :	26643},
          { date :	'2025-04-17',	total :	23091},
          { date :	'2025-04-18',	total :	14210},
          { date :	'2025-04-19',	total :	26051},
          { date :	'2025-04-20',	total :	29012},
          { date :	'2025-04-21',	total :	29604},
          { date :	'2025-04-22',	total :	11842},
          { date :	'2025-04-23',	total :	21907},
          { date :	'2025-04-24',	total :	13026},
          { date :	'2025-04-25',	total :	20723},
          { date :	'2025-04-26',	total :	14210},
          { date :	'2025-04-27',	total :	17170},
          { date :	'2025-04-28',	total :	22499},
          { date :	'2025-04-29',	total :	27235},
          { date :	'2025-04-30',	total :	25459},
          { date :	'2025-05-01',	total :	38550},
          { date :	'2025-05-02',	total :	40191},
          { date :	'2025-05-03',	total :	34449},
          { date :	'2025-05-04',	total :	32809},
          { date :	'2025-05-05',	total :	32809},
          { date :	'2025-05-06',	total :	33629},
          { date :	'2025-05-07',	total :	33629},
          { date :	'2025-05-08',	total :	36910},
          { date :	'2025-05-09',	total :	34449},
          { date :	'2025-05-10',	total :	35269},
          { date :	'2025-05-11',	total :	34449},
          { date :	'2025-05-12',	total :	38550},
          { date :	'2025-05-13',	total :	39370},
          { date :	'2025-05-14',	total :	36910},
          { date :	'2025-05-15',	total :	37730},
          { date :	'2025-05-16',	total :	37730},
          { date :	'2025-05-17',	total :	40191},
          { date :	'2025-05-18',	total :	41011},
          { date :	'2025-05-19',	total :	40191},
          { date :	'2025-05-20',	total :	37730},
          { date :	'2025-05-21',	total :	40191},
          { date :	'2025-05-22',	total :	32809},
          { date :	'2025-05-23',	total :	36090},
          { date :	'2025-05-24',	total :	32809},
          { date :	'2025-05-25',	total :	36910},
          { date :	'2025-05-26',	total :	33629},
          { date :	'2025-05-27',	total :	36090},
          { date :	'2025-05-28',	total :	36090},
          { date :	'2025-05-29',	total :	36910},
          { date :	'2025-05-30',	total :	37730},
          { date :	'2025-05-31',	total :	35269},
          { date :	'2025-06-01',	total :	41546},
          { date :	'2025-06-02',	total :	41546},
          { date :	'2025-06-03',	total :	38894},
          { date :	'2025-06-04',	total :	41546},
          { date :	'2025-06-05',	total :	39778},
          { date :	'2025-06-06',	total :	40662},
          { date :	'2025-06-07',	total :	42430},
          { date :	'2025-06-08',	total :	41546},
          { date :	'2025-06-09',	total :	44198},
          { date :	'2025-06-10',	total :	40662},
          { date :	'2025-06-11',	total :	35358},
          { date :	'2025-06-12',	total :	42430},
          { date :	'2025-06-13',	total :	43314},
          { date :	'2025-06-14',	total :	38010},
          { date :	'2025-06-15',	total :	42430},
          { date :	'2025-06-16',	total :	38010},
          { date :	'2025-06-17',	total :	44198},
          { date :	'2025-06-18',	total :	38894},
          { date :	'2025-06-19',	total :	38894},
          { date :	'2025-06-20',	total :	35358},
          { date :	'2025-06-21',	total :	39778},
          { date :	'2025-06-22',	total :	38010},
          { date :	'2025-06-23',	total :	38010},
          { date :	'2025-06-24',	total :	43314},
          { date :	'2025-06-25',	total :	39778},
          { date :	'2025-06-26',	total :	41546},
          { date :	'2025-06-27',	total :	41546},
          { date :	'2025-06-28',	total :	40662},
          { date :	'2025-06-29',	total :	36242},
          { date :	'2025-06-30',	total :	42430},
          { date :	'2025-07-01',	total :	43458},
          { date :	'2025-07-02',	total :	44152},
          { date :	'2025-07-03',	total :	41683},
          { date :	'2025-07-04',	total :	43478},
          { date :	'2025-07-05',	total :	42172},
          { date :	'2025-07-06',	total :	47253},
          { date :	'2025-07-07',	total :	46641},
          { date :	'2025-07-08',	total :	40315},
          { date :	'2025-07-09',	total :	41539},
          { date :	'2025-07-10',	total :	43152},
          { date :	'2025-07-11',	total :	30927},
          ],
        settings: [
          { label: 'API Key', value: 'op-****-****-**9N' },
          { label: 'Webhook URL', value: 'https://partner-api.ultimateteenpatti.com/v2/webhook' },
          { label: 'Client ID', value: '3-patti-2A4AcmQ80TBErwN-827' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
  'wcc': {
    logo: wcclogo,
    name: 'WCC',
    projects: {
      'Prod': {
        logo: wcclogo,
        name: 'Prod',
        stats: [
          { date: '2024-11-01', mau: 235377, installs: 55290 },
          { date: '2024-12-01', mau: 167133, installs: 3877 },
          { date: '2025-01-01', mau: 116447, installs: 4741 },
          { date: '2025-02-01', mau: 694738, installs: 46799 },
          { date: '2025-03-01', mau: 518545, installs: 13361 },
          { date: '2025-04-01', mau: 592076, installs: 4287 },
          { date: '2025-05-01', mau: 641908, installs: 33885 },
          { date: '2025-06-01', mau: 813240, installs: 29446 },
          { date: '2025-07-01', mau: 272963, installs: 9861 },
        ],
        days : [			
          { date :	'2024-11-01',	total :	9415},
          { date :	'2024-11-02',	total :	8944},
          { date :	'2024-11-03',	total :	8944},
          { date :	'2024-11-04',	total :	11298},
          { date :	'2024-11-05',	total :	10357},
          { date :	'2024-11-06',	total :	10827},
          { date :	'2024-11-07',	total :	9180},
          { date :	'2024-11-08',	total :	4943},
          { date :	'2024-11-09',	total :	4943},
          { date :	'2024-11-10',	total :	5178},
          { date :	'2024-11-11',	total :	10827},
          { date :	'2024-11-12',	total :	5884},
          { date :	'2024-11-13',	total :	7767},
          { date :	'2024-11-14',	total :	7297},
          { date :	'2024-11-15',	total :	6591},
          { date :	'2024-11-16',	total :	6591},
          { date :	'2024-11-17',	total :	6591},
          { date :	'2024-11-18',	total :	9180},
          { date :	'2024-11-19',	total :	10121},
          { date :	'2024-11-20',	total :	7767},
          { date :	'2024-11-21',	total :	8709},
          { date :	'2024-11-22',	total :	7297},
          { date :	'2024-11-23',	total :	5884},
          { date :	'2024-11-24',	total :	9415},
          { date :	'2024-11-25',	total :	11769},
          { date :	'2024-11-26',	total :	6355},
          { date :	'2024-11-27',	total :	9650},
          { date :	'2024-11-28',	total :	5414},
          { date :	'2024-11-29',	total :	5178},
          { date :	'2024-11-30',	total :	5649},
          { date :	'2024-12-01',	total :	5348},
          { date :	'2024-12-02',	total :	3844},
          { date :	'2024-12-03',	total :	5850},
          { date :	'2024-12-04',	total :	5181},
          { date :	'2024-12-05',	total :	4178},
          { date :	'2024-12-06',	total :	8190},
          { date :	'2024-12-07',	total :	3343},
          { date :	'2024-12-08',	total :	8357},
          { date :	'2024-12-09',	total :	8357},
          { date :	'2024-12-10',	total :	7020},
          { date :	'2024-12-11',	total :	4345},
          { date :	'2024-12-12',	total :	6685},
          { date :	'2024-12-13',	total :	5515},
          { date :	'2024-12-14',	total :	8357},
          { date :	'2024-12-15',	total :	3844},
          { date :	'2024-12-16',	total :	6017},
          { date :	'2024-12-17',	total :	8190},
          { date :	'2024-12-18',	total :	4680},
          { date :	'2024-12-19',	total :	6017},
          { date :	'2024-12-20',	total :	3844},
          { date :	'2024-12-21',	total :	7521},
          { date :	'2024-12-22',	total :	5014},
          { date :	'2024-12-23',	total :	7187},
          { date :	'2024-12-24',	total :	6017},
          { date :	'2024-12-25',	total :	5683},
          { date :	'2024-12-26',	total :	4513},
          { date :	'2024-12-27',	total :	5850},
          { date :	'2024-12-28',	total :	8022},
          { date :	'2024-12-29',	total :	8190},
          { date :	'2024-12-30',	total :	7187},
          { date :	'2024-12-31',	total :	4011},
          { date :	'2025-01-01',	total :	2678},
          { date :	'2025-01-02',	total :	2445},
          { date :	'2025-01-03',	total :	2445},
          { date :	'2025-01-04',	total :	2445},
          { date :	'2025-01-05',	total :	5007},
          { date :	'2025-01-06',	total :	3959},
          { date :	'2025-01-07',	total :	3959},
          { date :	'2025-01-08',	total :	5007},
          { date :	'2025-01-09',	total :	1863},
          { date :	'2025-01-10',	total :	2212},
          { date :	'2025-01-11',	total :	2212},
          { date :	'2025-01-12',	total :	2096},
          { date :	'2025-01-13',	total :	1863},
          { date :	'2025-01-14',	total :	2329},
          { date :	'2025-01-15',	total :	2212},
          { date :	'2025-01-16',	total :	2212},
          { date :	'2025-01-17',	total :	2212},
          { date :	'2025-01-18',	total :	2212},
          { date :	'2025-01-19',	total :	2329},
          { date :	'2025-01-20',	total :	2329},
          { date :	'2025-01-21',	total :	1747},
          { date :	'2025-01-22',	total :	1747},
          { date :	'2025-01-23',	total :	2329},
          { date :	'2025-01-24',	total :	1980},
          { date :	'2025-01-25',	total :	1980},
          { date :	'2025-01-26',	total :	1747},
          { date :	'2025-01-27',	total :	1980},
          { date :	'2025-01-28',	total :	1747},
          { date :	'2025-01-29',	total :	3028},
          { date :	'2025-01-30',	total :	2911},
          { date :	'2025-01-31',	total :	3028},
          { date :	'2025-02-01',	total :	20842},
          { date :	'2025-02-02',	total :	15979},
          { date :	'2025-02-03',	total :	13895},
          { date :	'2025-02-04',	total :	20842},
          { date :	'2025-02-05',	total :	19453},
          { date :	'2025-02-06',	total :	14589},
          { date :	'2025-02-07',	total :	20147},
          { date :	'2025-02-08',	total :	19453},
          { date :	'2025-02-09',	total :	15284},
          { date :	'2025-02-10',	total :	20147},
          { date :	'2025-02-11',	total :	18758},
          { date :	'2025-02-12',	total :	20147},
          { date :	'2025-02-13',	total :	15979},
          { date :	'2025-02-14',	total :	17368},
          { date :	'2025-02-15',	total :	13895},
          { date :	'2025-02-16',	total :	14589},
          { date :	'2025-02-17',	total :	17368},
          { date :	'2025-02-18',	total :	19453},
          { date :	'2025-02-19',	total :	18758},
          { date :	'2025-02-20',	total :	20147},
          { date :	'2025-02-21',	total :	14589},
          { date :	'2025-02-22',	total :	19453},
          { date :	'2025-02-23',	total :	13895},
          { date :	'2025-02-24',	total :	15284},
          { date :	'2025-02-25',	total :	20842},
          { date :	'2025-02-26',	total :	22232},
          { date :	'2025-02-27',	total :	14589},
          { date :	'2025-02-28',	total :	15979},
          { date :	'2025-03-01',	total :	17112},
          { date :	'2025-03-02',	total :	15038},
          { date :	'2025-03-03',	total :	23853},
          { date :	'2025-03-04',	total :	13482},
          { date :	'2025-03-05',	total :	20742},
          { date :	'2025-03-06',	total :	18668},
          { date :	'2025-03-07',	total :	20223},
          { date :	'2025-03-08',	total :	23335},
          { date :	'2025-03-09',	total :	10889},
          { date :	'2025-03-10',	total :	22297},
          { date :	'2025-03-11',	total :	21779},
          { date :	'2025-03-12',	total :	23853},
          { date :	'2025-03-13',	total :	13482},
          { date :	'2025-03-14',	total :	13482},
          { date :	'2025-03-15',	total :	13482},
          { date :	'2025-03-16',	total :	12964},
          { date :	'2025-03-17',	total :	10889},
          { date :	'2025-03-18',	total :	17112},
          { date :	'2025-03-19',	total :	15556},
          { date :	'2025-03-20',	total :	16593},
          { date :	'2025-03-21',	total :	12964},
          { date :	'2025-03-22',	total :	17112},
          { date :	'2025-03-23',	total :	16593},
          { date :	'2025-03-24',	total :	13482},
          { date :	'2025-03-25',	total :	14001},
          { date :	'2025-03-26',	total :	12445},
          { date :	'2025-03-27',	total :	19705},
          { date :	'2025-03-28',	total :	19705},
          { date :	'2025-03-29',	total :	18668},
          { date :	'2025-03-30',	total :	16593},
          { date :	'2025-03-31',	total :	16075},
          { date :	'2025-04-01',	total :	24867},
          { date :	'2025-04-02',	total :	14210},
          { date :	'2025-04-03',	total :	21315},
          { date :	'2025-04-04',	total :	29012},
          { date :	'2025-04-05',	total :	25459},
          { date :	'2025-04-06',	total :	11842},
          { date :	'2025-04-07',	total :	12434},
          { date :	'2025-04-08',	total :	29012},
          { date :	'2025-04-09',	total :	18946},
          { date :	'2025-04-10',	total :	29012},
          { date :	'2025-04-11',	total :	19539},
          { date :	'2025-04-12',	total :	20131},
          { date :	'2025-04-13',	total :	16578},
          { date :	'2025-04-14',	total :	21315},
          { date :	'2025-04-15',	total :	20131},
          { date :	'2025-04-16',	total :	17762},
          { date :	'2025-04-17',	total :	25459},
          { date :	'2025-04-18',	total :	21907},
          { date :	'2025-04-19',	total :	26643},
          { date :	'2025-04-20',	total :	20131},
          { date :	'2025-04-21',	total :	24867},
          { date :	'2025-04-22',	total :	11842},
          { date :	'2025-04-23',	total :	24867},
          { date :	'2025-04-24',	total :	15986},
          { date :	'2025-04-25',	total :	26051},
          { date :	'2025-04-26',	total :	16578},
          { date :	'2025-04-27',	total :	13026},
          { date :	'2025-04-28',	total :	20723},
          { date :	'2025-04-29',	total :	18354},
          { date :	'2025-04-30',	total :	17170},
          { date :	'2025-05-01',	total :	30170},
          { date :	'2025-05-02',	total :	28244},
          { date :	'2025-05-03',	total :	28886},
          { date :	'2025-05-04',	total :	30812},
          { date :	'2025-05-05',	total :	29528},
          { date :	'2025-05-06',	total :	30812},
          { date :	'2025-05-07',	total :	30812},
          { date :	'2025-05-08',	total :	31453},
          { date :	'2025-05-09',	total :	25676},
          { date :	'2025-05-10',	total :	29528},
          { date :	'2025-05-11',	total :	27602},
          { date :	'2025-05-12',	total :	30812},
          { date :	'2025-05-13',	total :	26318},
          { date :	'2025-05-14',	total :	28886},
          { date :	'2025-05-15',	total :	28244},
          { date :	'2025-05-16',	total :	27602},
          { date :	'2025-05-17',	total :	26318},
          { date :	'2025-05-18',	total :	28244},
          { date :	'2025-05-19',	total :	30170},
          { date :	'2025-05-20',	total :	29528},
          { date :	'2025-05-21',	total :	30812},
          { date :	'2025-05-22',	total :	28244},
          { date :	'2025-05-23',	total :	28244},
          { date :	'2025-05-24',	total :	26318},
          { date :	'2025-05-25',	total :	31453},
          { date :	'2025-05-26',	total :	32095},
          { date :	'2025-05-27',	total :	31453},
          { date :	'2025-05-28',	total :	32095},
          { date :	'2025-05-29',	total :	26318},
          { date :	'2025-05-30',	total :	25676},
          { date :	'2025-05-31',	total :	32095},
          { date :	'2025-06-01',	total :	39036},
          { date :	'2025-06-02',	total :	34156},
          { date :	'2025-06-03',	total :	34969},
          { date :	'2025-06-04',	total :	34969},
          { date :	'2025-06-05',	total :	32530},
          { date :	'2025-06-06',	total :	34969},
          { date :	'2025-06-07',	total :	35783},
          { date :	'2025-06-08',	total :	37409},
          { date :	'2025-06-09',	total :	35783},
          { date :	'2025-06-10',	total :	37409},
          { date :	'2025-06-11',	total :	34156},
          { date :	'2025-06-12',	total :	37409},
          { date :	'2025-06-13',	total :	39036},
          { date :	'2025-06-14',	total :	39036},
          { date :	'2025-06-15',	total :	32530},
          { date :	'2025-06-16',	total :	38222},
          { date :	'2025-06-17',	total :	33343},
          { date :	'2025-06-18',	total :	39036},
          { date :	'2025-06-19',	total :	33343},
          { date :	'2025-06-20',	total :	34156},
          { date :	'2025-06-21',	total :	40662},
          { date :	'2025-06-22',	total :	34156},
          { date :	'2025-06-23',	total :	34969},
          { date :	'2025-06-24',	total :	34969},
          { date :	'2025-06-25',	total :	35783},
          { date :	'2025-06-26',	total :	34156},
          { date :	'2025-06-27',	total :	37409},
          { date :	'2025-06-28',	total :	36596},
          { date :	'2025-06-29',	total :	36596},
          { date :	'2025-06-30',	total :	30662},
          { date :	'2025-07-01',	total :	29480},
          { date :	'2025-07-02',	total :	56776},
          { date :	'2025-07-03',	total :	36850},
          { date :	'2025-07-04',	total :	31118},
          { date :	'2025-07-05',	total :	32483},
          { date :	'2025-07-06',	total :	42309},
          { date :	'2025-07-07',	total :	33847},
          { date :	'2025-07-08',	total :	43128},
          { date :	'2025-07-09',	total :	31118},
          { date :	'2025-07-10',	total :	34396},
          { date :	'2025-07-11',	total :	28661},
          ],
        settings: [
          { label: 'API Key', value: 'wc-****-****-**0A' },
          { label: 'Webhook URL', value: 'https://api.worldcricketchampionship.com/app/v1/stan/webhook' },
          { label: 'Client ID', value: 'wcc-ovkzVCaYZRALMIs-238' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
  'icc_crictos': {
    logo: iccLogo,
    name: 'ICC Crictos',
    projects: {
      'Prod': {
        logo: iccLogo,
        name: 'Prod',
        stats: [
          { date: '2025-02-01', mau: 694738, installs: 58499 },
          { date: '2025-03-01', mau: 456320, installs: 11877 },
          { date: '2025-04-01', mau: 548218, installs: 4287 },
          { date: '2025-05-01', mau: 641908, installs: 33885 },
          { date: '2025-06-01', mau: 601090, installs: 30918 },
          { date: '2025-07-01', mau: 238829, installs: 10076 },
        ],
        days : [			
          { date :	'2025-02-01',	total :	19453},
          { date :	'2025-02-02',	total :	20147},
          { date :	'2025-02-03',	total :	17368},
          { date :	'2025-02-04',	total :	18063},
          { date :	'2025-02-05',	total :	15979},
          { date :	'2025-02-06',	total :	13895},
          { date :	'2025-02-07',	total :	15284},
          { date :	'2025-02-08',	total :	16674},
          { date :	'2025-02-09',	total :	20842},
          { date :	'2025-02-10',	total :	18758},
          { date :	'2025-02-11',	total :	15284},
          { date :	'2025-02-12',	total :	16674},
          { date :	'2025-02-13',	total :	20147},
          { date :	'2025-02-14',	total :	19453},
          { date :	'2025-02-15',	total :	20842},
          { date :	'2025-02-16',	total :	13895},
          { date :	'2025-02-17',	total :	20147},
          { date :	'2025-02-18',	total :	16674},
          { date :	'2025-02-19',	total :	13895},
          { date :	'2025-02-20',	total :	15979},
          { date :	'2025-02-21',	total :	13895},
          { date :	'2025-02-22',	total :	13895},
          { date :	'2025-02-23',	total :	18758},
          { date :	'2025-02-24',	total :	15284},
          { date :	'2025-02-25',	total :	16674},
          { date :	'2025-02-26',	total :	23621},
          { date :	'2025-02-27',	total :	26400},
          { date :	'2025-02-28',	total :	29179},
          { date :	'2025-03-01',	total :	21903},
          { date :	'2025-03-02',	total :	18709},
          { date :	'2025-03-03',	total :	19165},
          { date :	'2025-03-04',	total :	20991},
          { date :	'2025-03-05',	total :	10952},
          { date :	'2025-03-06',	total :	20534},
          { date :	'2025-03-07',	total :	20534},
          { date :	'2025-03-08',	total :	9583},
          { date :	'2025-03-09',	total :	14146},
          { date :	'2025-03-10',	total :	13233},
          { date :	'2025-03-11',	total :	12321},
          { date :	'2025-03-12',	total :	14602},
          { date :	'2025-03-13',	total :	9583},
          { date :	'2025-03-14',	total :	19165},
          { date :	'2025-03-15',	total :	15515},
          { date :	'2025-03-16',	total :	16428},
          { date :	'2025-03-17',	total :	18253},
          { date :	'2025-03-18',	total :	15515},
          { date :	'2025-03-19',	total :	22360},
          { date :	'2025-03-20',	total :	17796},
          { date :	'2025-03-21',	total :	16428},
          { date :	'2025-03-22',	total :	20078},
          { date :	'2025-03-23',	total :	11864},
          { date :	'2025-03-24',	total :	17796},
          { date :	'2025-03-25',	total :	20078},
          { date :	'2025-03-26',	total :	15515},
          { date :	'2025-03-27',	total :	10495},
          { date :	'2025-03-28',	total :	15515},
          { date :	'2025-03-29',	total :	11408},
          { date :	'2025-03-30',	total :	19622},
          { date :	'2025-03-31',	total :	20991},
          { date :	'2025-04-01',	total :	16447},
          { date :	'2025-04-02',	total :	19736},
          { date :	'2025-04-03',	total :	15898},
          { date :	'2025-04-04',	total :	12609},
          { date :	'2025-04-05',	total :	11513},
          { date :	'2025-04-06',	total :	19188},
          { date :	'2025-04-07',	total :	12609},
          { date :	'2025-04-08',	total :	20832},
          { date :	'2025-04-09',	total :	18091},
          { date :	'2025-04-10',	total :	15898},
          { date :	'2025-04-11',	total :	27411},
          { date :	'2025-04-12',	total :	12609},
          { date :	'2025-04-13',	total :	21929},
          { date :	'2025-04-14',	total :	22477},
          { date :	'2025-04-15',	total :	16447},
          { date :	'2025-04-16',	total :	12609},
          { date :	'2025-04-17',	total :	21381},
          { date :	'2025-04-18',	total :	12061},
          { date :	'2025-04-19',	total :	25218},
          { date :	'2025-04-20',	total :	26314},
          { date :	'2025-04-21',	total :	17543},
          { date :	'2025-04-22',	total :	14802},
          { date :	'2025-04-23',	total :	12061},
          { date :	'2025-04-24',	total :	20284},
          { date :	'2025-04-25',	total :	12609},
          { date :	'2025-04-26',	total :	24122},
          { date :	'2025-04-27',	total :	23025},
          { date :	'2025-04-28',	total :	23025},
          { date :	'2025-04-29',	total :	22477},
          { date :	'2025-04-30',	total :	21929},
          { date :	'2025-05-01',	total :	26318},
          { date :	'2025-05-02',	total :	31453},
          { date :	'2025-05-03',	total :	32095},
          { date :	'2025-05-04',	total :	32095},
          { date :	'2025-05-05',	total :	32095},
          { date :	'2025-05-06',	total :	26318},
          { date :	'2025-05-07',	total :	28244},
          { date :	'2025-05-08',	total :	26960},
          { date :	'2025-05-09',	total :	26318},
          { date :	'2025-05-10',	total :	28886},
          { date :	'2025-05-11',	total :	28886},
          { date :	'2025-05-12',	total :	28886},
          { date :	'2025-05-13',	total :	28886},
          { date :	'2025-05-14',	total :	28886},
          { date :	'2025-05-15',	total :	30170},
          { date :	'2025-05-16',	total :	31453},
          { date :	'2025-05-17',	total :	30812},
          { date :	'2025-05-18',	total :	25676},
          { date :	'2025-05-19',	total :	28244},
          { date :	'2025-05-20',	total :	26960},
          { date :	'2025-05-21',	total :	25676},
          { date :	'2025-05-22',	total :	32095},
          { date :	'2025-05-23',	total :	27602},
          { date :	'2025-05-24',	total :	31453},
          { date :	'2025-05-25',	total :	28244},
          { date :	'2025-05-26',	total :	27602},
          { date :	'2025-05-27',	total :	27602},
          { date :	'2025-05-28',	total :	30170},
          { date :	'2025-05-29',	total :	32095},
          { date :	'2025-05-30',	total :	27602},
          { date :	'2025-05-31',	total :	30170},
          { date :	'2025-06-01',	total :	24044},
          { date :	'2025-06-02',	total :	28852},
          { date :	'2025-06-03',	total :	25246},
          { date :	'2025-06-04',	total :	27049},
          { date :	'2025-06-05',	total :	27650},
          { date :	'2025-06-06',	total :	26448},
          { date :	'2025-06-07',	total :	25246},
          { date :	'2025-06-08',	total :	26448},
          { date :	'2025-06-09',	total :	30055},
          { date :	'2025-06-10',	total :	29453},
          { date :	'2025-06-11',	total :	28852},
          { date :	'2025-06-12',	total :	25246},
          { date :	'2025-06-13',	total :	30055},
          { date :	'2025-06-14',	total :	30055},
          { date :	'2025-06-15',	total :	24645},
          { date :	'2025-06-16',	total :	24044},
          { date :	'2025-06-17',	total :	27650},
          { date :	'2025-06-18',	total :	30055},
          { date :	'2025-06-19',	total :	25246},
          { date :	'2025-06-20',	total :	27650},
          { date :	'2025-06-21',	total :	25847},
          { date :	'2025-06-22',	total :	28251},
          { date :	'2025-06-23',	total :	26448},
          { date :	'2025-06-24',	total :	27650},
          { date :	'2025-06-25',	total :	27650},
          { date :	'2025-06-26',	total :	28852},
          { date :	'2025-06-27',	total :	30055},
          { date :	'2025-06-28',	total :	30055},
          { date :	'2025-06-29',	total :	29453},
          { date :	'2025-06-30',	total :	30055},
          { date :	'2025-07-01',	total :	34869},
          { date :	'2025-07-02',	total :	43945},
          { date :	'2025-07-03',	total :	32242},
          { date :	'2025-07-04',	total :	28421},
          { date :	'2025-07-05',	total :	27704},
          { date :	'2025-07-06',	total :	29376},
          { date :	'2025-07-07',	total :	35586},
          { date :	'2025-07-08',	total :	32720},
          { date :	'2025-07-09',	total :	35586},
          { date :	'2025-07-10',	total :	36764},
          { date :	'2025-07-11',	total :	24153},
          ],
        settings: [
          { label: 'API Key', value: 'pr-****-****-**DC' },
          { label: 'Webhook URL', value: 'https://apis.fancraze.com/v1_2/partner/webhook' },
          { label: 'Client ID', value: 'icc-mLk6z2KuZVrUszw-435' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
  'voice_club': {
    logo: voiceClubLogo,
    name: 'Voice Club',
    projects: {
      'Prod': {
        logo: voiceClubLogo,
        name: 'Prod',
        stats: [
          { date: '2025-02-01', mau: 51462, installs: 23400 },
          { date: '2025-03-01', mau: 186676, installs: 990 },
          { date: '2025-04-01', mau: 65786, installs: 2338 },
          { date: '2025-05-01', mau: 299557, installs: 14981 },
          { date: '2025-06-01', mau: 190935, installs: 7950 },
          { date: '2025-07-01', mau: 74170, installs: 3685 },
        ],
        days : [			
          { date :	'2025-02-01',	total :	1235},
          { date :	'2025-02-02',	total :	1184},
          { date :	'2025-02-03',	total :	1132},
          { date :	'2025-02-04',	total :	1184},
          { date :	'2025-02-05',	total :	1287},
          { date :	'2025-02-06',	total :	1389},
          { date :	'2025-02-07',	total :	1287},
          { date :	'2025-02-08',	total :	1287},
          { date :	'2025-02-09',	total :	1544},
          { date :	'2025-02-10',	total :	1029},
          { date :	'2025-02-11',	total :	1338},
          { date :	'2025-02-12',	total :	1132},
          { date :	'2025-02-13',	total :	1544},
          { date :	'2025-02-14',	total :	1235},
          { date :	'2025-02-15',	total :	1235},
          { date :	'2025-02-16',	total :	1132},
          { date :	'2025-02-17',	total :	1235},
          { date :	'2025-02-18',	total :	1029},
          { date :	'2025-02-19',	total :	1389},
          { date :	'2025-02-20',	total :	1441},
          { date :	'2025-02-21',	total :	1338},
          { date :	'2025-02-22',	total :	1544},
          { date :	'2025-02-23',	total :	1338},
          { date :	'2025-02-24',	total :	1389},
          { date :	'2025-02-25',	total :	1029},
          { date :	'2025-02-26',	total :	2316},
          { date :	'2025-02-27',	total :	1389},
          { date :	'2025-02-28',	total :	2213},
          { date :	'2025-03-01',	total :	3734},
          { date :	'2025-03-02',	total :	6347},
          { date :	'2025-03-03',	total :	8587},
          { date :	'2025-03-04',	total :	6534},
          { date :	'2025-03-05',	total :	4480},
          { date :	'2025-03-06',	total :	5787},
          { date :	'2025-03-07',	total :	6347},
          { date :	'2025-03-08',	total :	6160},
          { date :	'2025-03-09',	total :	6720},
          { date :	'2025-03-10',	total :	5787},
          { date :	'2025-03-11',	total :	7094},
          { date :	'2025-03-12',	total :	6907},
          { date :	'2025-03-13',	total :	6907},
          { date :	'2025-03-14',	total :	8960},
          { date :	'2025-03-15',	total :	8214},
          { date :	'2025-03-16',	total :	8027},
          { date :	'2025-03-17',	total :	8587},
          { date :	'2025-03-18',	total :	9334},
          { date :	'2025-03-19',	total :	7840},
          { date :	'2025-03-20',	total :	5974},
          { date :	'2025-03-21',	total :	8400},
          { date :	'2025-03-22',	total :	6347},
          { date :	'2025-03-23',	total :	8587},
          { date :	'2025-03-24',	total :	9334},
          { date :	'2025-03-25',	total :	9147},
          { date :	'2025-03-26',	total :	9147},
          { date :	'2025-03-27',	total :	8587},
          { date :	'2025-03-28',	total :	4667},
          { date :	'2025-03-29',	total :	4294},
          { date :	'2025-03-30',	total :	4854},
          { date :	'2025-03-31',	total :	5600},
          { date :	'2025-04-01',	total :	1447},
          { date :	'2025-04-02',	total :	1645},
          { date :	'2025-04-03',	total :	2763},
          { date :	'2025-04-04',	total :	2303},
          { date :	'2025-04-05',	total :	2631},
          { date :	'2025-04-06',	total :	1908},
          { date :	'2025-04-07',	total :	2763},
          { date :	'2025-04-08',	total :	2829},
          { date :	'2025-04-09',	total :	2631},
          { date :	'2025-04-10',	total :	3289},
          { date :	'2025-04-11',	total :	2237},
          { date :	'2025-04-12',	total :	2829},
          { date :	'2025-04-13',	total :	1579},
          { date :	'2025-04-14',	total :	1710},
          { date :	'2025-04-15',	total :	1316},
          { date :	'2025-04-16',	total :	1382},
          { date :	'2025-04-17',	total :	1908},
          { date :	'2025-04-18',	total :	2237},
          { date :	'2025-04-19',	total :	1579},
          { date :	'2025-04-20',	total :	2434},
          { date :	'2025-04-21',	total :	1645},
          { date :	'2025-04-22',	total :	2171},
          { date :	'2025-04-23',	total :	1513},
          { date :	'2025-04-24',	total :	2829},
          { date :	'2025-04-25',	total :	2829},
          { date :	'2025-04-26',	total :	2697},
          { date :	'2025-04-27',	total :	1710},
          { date :	'2025-04-28',	total :	1316},
          { date :	'2025-04-29',	total :	1447},
          { date :	'2025-04-30',	total :	1382},
          { date :	'2025-05-01',	total :	11982},
          { date :	'2025-05-02',	total :	12581},
          { date :	'2025-05-03',	total :	13780},
          { date :	'2025-05-04',	total :	13480},
          { date :	'2025-05-05',	total :	13480},
          { date :	'2025-05-06',	total :	13181},
          { date :	'2025-05-07',	total :	13780},
          { date :	'2025-05-08',	total :	13780},
          { date :	'2025-05-09',	total :	13480},
          { date :	'2025-05-10',	total :	11982},
          { date :	'2025-05-11',	total :	13181},
          { date :	'2025-05-12',	total :	14678},
          { date :	'2025-05-13',	total :	14678},
          { date :	'2025-05-14',	total :	11982},
          { date :	'2025-05-15',	total :	11982},
          { date :	'2025-05-16',	total :	14978},
          { date :	'2025-05-17',	total :	12581},
          { date :	'2025-05-18',	total :	14678},
          { date :	'2025-05-19',	total :	12581},
          { date :	'2025-05-20',	total :	13181},
          { date :	'2025-05-21',	total :	14978},
          { date :	'2025-05-22',	total :	13181},
          { date :	'2025-05-23',	total :	13181},
          { date :	'2025-05-24',	total :	13480},
          { date :	'2025-05-25',	total :	14079},
          { date :	'2025-05-26',	total :	12581},
          { date :	'2025-05-27',	total :	14079},
          { date :	'2025-05-28',	total :	12282},
          { date :	'2025-05-29',	total :	13780},
          { date :	'2025-05-30',	total :	14678},
          { date :	'2025-05-31',	total :	12282},
          { date :	'2025-06-01',	total :	9356},
          { date :	'2025-06-02',	total :	8783},
          { date :	'2025-06-03',	total :	9165},
          { date :	'2025-06-04',	total :	9547},
          { date :	'2025-06-05',	total :	9547},
          { date :	'2025-06-06',	total :	7637},
          { date :	'2025-06-07',	total :	9356},
          { date :	'2025-06-08',	total :	9165},
          { date :	'2025-06-09',	total :	8783},
          { date :	'2025-06-10',	total :	9547},
          { date :	'2025-06-11',	total :	8401},
          { date :	'2025-06-12',	total :	7828},
          { date :	'2025-06-13',	total :	7828},
          { date :	'2025-06-14',	total :	8783},
          { date :	'2025-06-15',	total :	8401},
          { date :	'2025-06-16',	total :	8783},
          { date :	'2025-06-17',	total :	8210},
          { date :	'2025-06-18',	total :	8592},
          { date :	'2025-06-19',	total :	9356},
          { date :	'2025-06-20',	total :	8974},
          { date :	'2025-06-21',	total :	8783},
          { date :	'2025-06-22',	total :	9356},
          { date :	'2025-06-23',	total :	7637},
          { date :	'2025-06-24',	total :	8019},
          { date :	'2025-06-25',	total :	9547},
          { date :	'2025-06-26',	total :	9547},
          { date :	'2025-06-27',	total :	7637},
          { date :	'2025-06-28',	total :	7828},
          { date :	'2025-06-29',	total :	8592},
          { date :	'2025-06-30',	total :	8828},
          { date :	'2025-07-01',	total :	9642},
          { date :	'2025-07-02',	total :	8215},
          { date :	'2025-07-03',	total :	7788},
          { date :	'2025-07-04',	total :	10235},
          { date :	'2025-07-05',	total :	11645},
          { date :	'2025-07-06',	total :	10903},
          { date :	'2025-07-07',	total :	10755},
          { date :	'2025-07-08',	total :	8862},
          { date :	'2025-07-09',	total :	9491},
          { date :	'2025-07-10',	total :	10714},
          { date :	'2025-07-11',	total :	5307},
          ],
        settings: [
          { label: 'API Key', value: 'gy-****-****-**QA' },
          { label: 'Webhook URL', value: 'https://api.voiceclub.app/v1/stan/webhook' },
          { label: 'Client ID', value: 'vc-6ChJFWmHMr2USku-913' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
  'faug': {
    logo: faugLogo,
    name: 'Faug',
    projects: {
      'Prod': {
        logo: faugLogo,
        name: 'Prod',
        stats: [
          { date: '2025-05-01', mau: 228234, installs: 10165 },
          { date: '2025-06-01', mau: 176791, installs: 8392 },
          { date: '2025-07-01', mau: 81005, installs: 4059 },
        ],
        days : [			
          { date :	'2025-05-01',	total :	9586},
          { date :	'2025-05-02',	total :	11412},
          { date :	'2025-05-03',	total :	10271},
          { date :	'2025-05-04',	total :	10499},
          { date :	'2025-05-05',	total :	10499},
          { date :	'2025-05-06',	total :	10955},
          { date :	'2025-05-07',	total :	9129},
          { date :	'2025-05-08',	total :	10955},
          { date :	'2025-05-09',	total :	11412},
          { date :	'2025-05-10',	total :	9586},
          { date :	'2025-05-11',	total :	10727},
          { date :	'2025-05-12',	total :	9586},
          { date :	'2025-05-13',	total :	10271},
          { date :	'2025-05-14',	total :	9129},
          { date :	'2025-05-15',	total :	9814},
          { date :	'2025-05-16',	total :	9586},
          { date :	'2025-05-17',	total :	10955},
          { date :	'2025-05-18',	total :	10042},
          { date :	'2025-05-19',	total :	10499},
          { date :	'2025-05-20',	total :	10042},
          { date :	'2025-05-21',	total :	10499},
          { date :	'2025-05-22',	total :	10727},
          { date :	'2025-05-23',	total :	9129},
          { date :	'2025-05-24',	total :	10499},
          { date :	'2025-05-25',	total :	10499},
          { date :	'2025-05-26',	total :	10955},
          { date :	'2025-05-27',	total :	11183},
          { date :	'2025-05-28',	total :	11412},
          { date :	'2025-05-29',	total :	11183},
          { date :	'2025-05-30',	total :	11183},
          { date :	'2025-05-31',	total :	9129},
          { date :	'2025-06-01',	total :	7248},
          { date :	'2025-06-02',	total :	8840},
          { date :	'2025-06-03',	total :	7248},
          { date :	'2025-06-04',	total :	8840},
          { date :	'2025-06-05',	total :	8132},
          { date :	'2025-06-06',	total :	7956},
          { date :	'2025-06-07',	total :	7248},
          { date :	'2025-06-08',	total :	8132},
          { date :	'2025-06-09',	total :	7425},
          { date :	'2025-06-10',	total :	8486},
          { date :	'2025-06-11',	total :	8309},
          { date :	'2025-06-12',	total :	8309},
          { date :	'2025-06-13',	total :	8132},
          { date :	'2025-06-14',	total :	7956},
          { date :	'2025-06-15',	total :	8663},
          { date :	'2025-06-16',	total :	7425},
          { date :	'2025-06-17',	total :	8309},
          { date :	'2025-06-18',	total :	7779},
          { date :	'2025-06-19',	total :	8486},
          { date :	'2025-06-20',	total :	8840},
          { date :	'2025-06-21',	total :	7779},
          { date :	'2025-06-22',	total :	7248},
          { date :	'2025-06-23',	total :	8132},
          { date :	'2025-06-24',	total :	7072},
          { date :	'2025-06-25',	total :	7956},
          { date :	'2025-06-26',	total :	8132},
          { date :	'2025-06-27',	total :	7602},
          { date :	'2025-06-28',	total :	8309},
          { date :	'2025-06-29',	total :	8486},
          { date :	'2025-06-30',	total :	8486},
          { date :	'2025-07-01',	total :	8830},
          { date :	'2025-07-02',	total :	9606},
          { date :	'2025-07-03',	total :	8425},
          { date :	'2025-07-04',	total :	12637},
          { date :	'2025-07-05',	total :	8830},
          { date :	'2025-07-06',	total :	8587},
          { date :	'2025-07-07',	total :	8506},
          { date :	'2025-07-08',	total :	10693},
          { date :	'2025-07-09',	total :	8992},
          { date :	'2025-07-10',	total :	9802},
          { date :	'2025-07-11',	total :	7154},
          ],
        settings: [
          { label: 'API Key', value: 'LK-****-****-**61' },
          { label: 'Webhook URL', value: 'https://dot9adda.appspot.com/api/v1/stan' },
          { label: 'Client ID', value: 'faug-jcprESFnBPDDHnN-019' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
  'jigri': {
    logo: jigriLogo,
    name: 'Jigri',
    projects: {
      'Prod': {
        logo: jigriLogo,
        name: 'Prod',
        stats: [
          { date: '2025-05-01', mau: 256763, installs: 5172 },
          { date: '2025-06-01', mau: 198006, installs: 5742 },
          { date: '2025-07-01', mau: 90954, installs: 2387 },
        ],
        days : [			
          { date :	'2025-05-01',	total :	12581},
          { date :	'2025-05-02',	total :	12838},
          { date :	'2025-05-03',	total :	12581},
          { date :	'2025-05-04',	total :	11041},
          { date :	'2025-05-05',	total :	10271},
          { date :	'2025-05-06',	total :	11041},
          { date :	'2025-05-07',	total :	10527},
          { date :	'2025-05-08',	total :	10784},
          { date :	'2025-05-09',	total :	12068},
          { date :	'2025-05-10',	total :	10527},
          { date :	'2025-05-11',	total :	11041},
          { date :	'2025-05-12',	total :	11298},
          { date :	'2025-05-13',	total :	12325},
          { date :	'2025-05-14',	total :	12068},
          { date :	'2025-05-15',	total :	12325},
          { date :	'2025-05-16',	total :	11811},
          { date :	'2025-05-17',	total :	11811},
          { date :	'2025-05-18',	total :	12581},
          { date :	'2025-05-19',	total :	10527},
          { date :	'2025-05-20',	total :	12838},
          { date :	'2025-05-21',	total :	12325},
          { date :	'2025-05-22',	total :	10271},
          { date :	'2025-05-23',	total :	10784},
          { date :	'2025-05-24',	total :	12838},
          { date :	'2025-05-25',	total :	12838},
          { date :	'2025-05-26',	total :	11298},
          { date :	'2025-05-27',	total :	12325},
          { date :	'2025-05-28',	total :	11041},
          { date :	'2025-05-29',	total :	10784},
          { date :	'2025-05-30',	total :	11041},
          { date :	'2025-05-31',	total :	11298},
          { date :	'2025-06-01',	total :	8712},
          { date :	'2025-06-02',	total :	9504},
          { date :	'2025-06-03',	total :	8712},
          { date :	'2025-06-04',	total :	9108},
          { date :	'2025-06-05',	total :	9702},
          { date :	'2025-06-06',	total :	8514},
          { date :	'2025-06-07',	total :	9504},
          { date :	'2025-06-08',	total :	9900},
          { date :	'2025-06-09',	total :	9108},
          { date :	'2025-06-10',	total :	8316},
          { date :	'2025-06-11',	total :	8910},
          { date :	'2025-06-12',	total :	8514},
          { date :	'2025-06-13',	total :	9504},
          { date :	'2025-06-14',	total :	8118},
          { date :	'2025-06-15',	total :	9108},
          { date :	'2025-06-16',	total :	9306},
          { date :	'2025-06-17',	total :	8910},
          { date :	'2025-06-18',	total :	8118},
          { date :	'2025-06-19',	total :	8118},
          { date :	'2025-06-20',	total :	9108},
          { date :	'2025-06-21',	total :	8316},
          { date :	'2025-06-22',	total :	9306},
          { date :	'2025-06-23',	total :	9108},
          { date :	'2025-06-24',	total :	8514},
          { date :	'2025-06-25',	total :	8118},
          { date :	'2025-06-26',	total :	9108},
          { date :	'2025-06-27',	total :	8316},
          { date :	'2025-06-28',	total :	8316},
          { date :	'2025-06-29',	total :	9504},
          { date :	'2025-06-30',	total :	8910},
          { date :	'2025-07-01',	total :	10005},
          { date :	'2025-07-02',	total :	11645},
          { date :	'2025-07-03',	total :	9823},
          { date :	'2025-07-04',	total :	10642},
          { date :	'2025-07-05',	total :	12915},
          { date :	'2025-07-06',	total :	12370},
          { date :	'2025-07-07',	total :	11551},
          { date :	'2025-07-08',	total :	12825},
          { date :	'2025-07-09',	total :	10824},
          { date :	'2025-07-10',	total :	12095},
          { date :	'2025-07-11',	total :	7277},
          ],
        settings: [
          { label: 'API Key', value: 'BX-****-****-**IM' },
          { label: 'Webhook URL', value: 'https://api.jigri.app/v1/partner/webhook/stan' },
          { label: 'Client ID', value: 'jigri-p3EJWVPfT6J4v0l-743' },
          { label: 'Secret', value: '*************************************' },
        ],
      },
    },
  },
};

export default DUMMY_DATA; 